import { createDCHook, collapseDataFromCall } from '../client';
import { getOpeningHoursContactServiceDesk } from '../services/ContactService';

export const useContactGetOpeningHoursContactServiceDesk = createDCHook(
  'getOpeningHoursContactServiceDesk',
  collapseDataFromCall(getOpeningHoursContactServiceDesk),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
  { maxAge: 300000 },
);
